import React from 'react';
import styles from './css/ReasonsBlock.styl';
import Reason from './Reason';
import {CostReasonIcon, PlanReasonIcon, EaseReasonIcon} from './Svgs';

const ReasonsBlock = () => {
  const blurb3 =
    "Get funeral services covered now so it doesn't cost more later.";

  return (
    <div className={styles.ReasonsBlock}>
      <h2 className={styles.Title}>3 Reasons to Plan a Funeral in Advance</h2>
      <div className={styles.Reasons}>
        <Reason
          icon={<PlanReasonIcon />}
          title="Make your last wishes clear"
          blurb="Have the comfort of knowing your plans will be followed."
        />
        <Reason
          icon={<EaseReasonIcon />}
          title="Make it easier on loved ones"
          blurb="Save your family from added stress during a difficult time."
        />
        <Reason
          icon={<CostReasonIcon />}
          title="Make smart spending decisions"
          blurb={blurb3}
        />
      </div>
    </div>
  );
};

export default ReasonsBlock;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/components/ReasonsBlock/index.js